module.exports = __webpack_public_path__ + "img/desk1.bdee4e3e.png";